var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _g, _line, _path6, _rect11, _circle, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassportOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.688 102.428C114.688 105.962 111.822 108.827 108.288 108.827H17.6338C14.0996 108.827 11.2344 105.962 11.2344 102.428V19.2393H108.288C111.822 19.2393 114.688 22.1045 114.688 25.6387V102.428Z",
    fill: "#C9D1DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10156 23.5056C9.10156 19.9714 11.9666 17.1064 15.5007 17.1064H106.156C109.69 17.1064 112.555 19.9714 112.555 23.5056V64.0335H9.10156V23.5056Z",
    fill: "url(#paint0_linear_3752_129141)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8298 85.3644C43.4535 85.3644 29.3672 71.2782 29.3672 53.9019C29.3672 36.5257 43.4535 22.4395 60.8298 22.4395C78.206 22.4395 92.2923 36.5257 92.2923 53.9019C92.2923 71.2782 78.206 85.3644 60.8298 85.3644ZM60.8298 28.7319C60.239 28.7319 59.653 28.7523 59.0724 28.7923C58.9649 28.9286 58.8489 29.0789 58.7257 29.2432C57.941 30.2895 56.8644 31.8993 55.7782 34.0718C54.8013 36.0256 53.8137 38.4398 53.0235 41.3169H68.636C67.8458 38.4398 66.8582 36.0256 65.8813 34.0718C64.7951 31.8993 63.7185 30.2895 62.9338 29.2432C62.8106 29.0789 62.6946 28.9286 62.5871 28.7923C62.0065 28.7523 61.4205 28.7319 60.8298 28.7319ZM45.0985 53.9019C45.0985 51.6847 45.2218 49.5871 45.4416 47.6094H36.4527C35.935 49.6206 35.6597 51.7291 35.6597 53.9019C35.6597 56.0747 35.935 58.1832 36.4527 60.1944H45.4416C45.2218 58.2167 45.0985 56.1191 45.0985 53.9019ZM46.5291 66.4869H39.027C41.614 70.9591 45.5376 74.5615 50.2515 76.7478L50.15 76.5461C48.8107 73.8675 47.4858 70.513 46.5291 66.4869ZM53.0235 66.4869H68.636C67.8458 69.3641 66.8582 71.7782 65.8813 73.732C64.7951 75.9045 63.7185 77.5144 62.9338 78.5606C62.8106 78.7249 62.6946 78.8752 62.5871 79.0115C62.0065 79.0515 61.4205 79.0719 60.8298 79.0719C60.239 79.0719 59.653 79.0515 59.0724 79.0115C58.9649 78.8752 58.8489 78.7249 58.7257 78.5606C57.941 77.5144 56.8644 75.9045 55.7782 73.732C54.8013 71.7782 53.8137 69.3641 53.0235 66.4869ZM69.8814 60.1944L51.7781 60.1944C51.5322 58.2426 51.391 56.1452 51.391 53.9019C51.391 51.6586 51.5322 49.5613 51.7781 47.6094H69.8814C70.1273 49.5613 70.2685 51.6586 70.2685 53.9019C70.2685 56.1452 70.1273 58.2426 69.8814 60.1944ZM75.1304 66.4869C74.1737 70.513 72.8488 73.8675 71.5095 76.5461L71.408 76.7478C76.1219 74.5615 80.0455 70.9591 82.6325 66.4869H75.1304ZM85.2068 60.1944H76.2179C76.4377 58.2167 76.561 56.1191 76.561 53.9019C76.561 51.6847 76.4377 49.5871 76.2179 47.6094H85.2068C85.7245 49.6206 85.9998 51.7291 85.9998 53.9019C85.9998 56.0747 85.7245 58.1832 85.2068 60.1944ZM50.15 31.2577C48.8107 33.9364 47.4858 37.2909 46.5291 41.3169H39.027C41.614 36.8447 45.5376 33.2424 50.2515 31.0561L50.15 31.2577ZM71.408 31.0561C76.1219 33.2424 80.0455 36.8447 82.6325 41.3169H75.1304C74.1737 37.2909 72.8488 33.9364 71.5095 31.2577L71.408 31.0561Z",
    fill: "black",
    fillOpacity: 0.54
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10156 64.0332H112.555V100.295C112.555 103.829 109.69 106.694 106.156 106.694H15.5007C11.9666 106.694 9.10156 103.829 9.10156 100.295V64.0332Z",
    fill: "url(#paint1_linear_3752_129141)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.149 100.541C34.2949 98.8814 35.1798 95.2876 34.9706 92.7762C34.7932 90.6464 33.2243 90.4701 31.3467 91.1146C28.4296 92.1158 25.2357 93.8307 24.6337 96.9983C24.1891 99.3376 23.8677 103.243 26.9471 103.994C29.5817 104.637 31.5813 101.098 31.4002 98.8991C31.307 97.7681 29.7687 98.2544 29.5949 99.1254C29.1167 101.522 31.8888 102.69 33.9811 102.378C35.0395 102.22 35.8489 101.578 36.4683 100.768C36.5945 100.603 36.8502 99.8464 37.1637 100.063C38.0325 100.663 38.9505 101.066 39.8516 101.589",
    stroke: "#C4CDD5",
    strokeWidth: 0.738095,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70.1624,
    height: 2.66634,
    rx: 1.06653,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 39.6641 96.0293)",
    fill: "#83888E",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 75.7475,
    height: 2.66634,
    rx: 1.06653,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 34.0781 100.829)",
    fill: "#83888E",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 13.7138,
    height: 1.19732,
    rx: 0.598658,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 40.1328 73.0986)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 18.3583,
    height: 1.19732,
    rx: 0.598658,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 40.1328 79.498)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 27.9201,
    height: 1.19732,
    rx: 0.598658,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 40.1328 89.6299)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 5.71879,
    height: 1.19732,
    rx: 0.598658,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 40.0312 75.6553)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 10.344,
    height: 1.19732,
    rx: 0.598658,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 40.0312 82.0547)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 28.231,
    height: 1.19732,
    rx: 0.598658,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 40.0312 92.1865)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3672,
    y: 72.5654,
    width: 21.3306,
    height: 21.3305,
    fill: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3752_129141",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 72,
    width: 22,
    height: 22
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3672,
    y: 72.5654,
    width: 21.3306,
    height: 21.3305,
    fill: "#F9F9F9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3752_129141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1703 77.853L19.0125 79.1225C18.6947 81.6787 20.6903 83.9354 23.2662 83.9354C23.757 83.9354 24.2445 84.0201 24.7066 84.1856C27.4881 85.182 30.4166 83.1204 30.4166 80.1658V78.6672C30.4166 77.9909 30.1973 77.3328 29.7915 76.7917L28.9622 75.6858C28.3139 74.8212 27.4602 74.1318 26.4785 73.68C24.7882 72.902 22.7832 73.4559 21.732 74.9913L21.4616 75.3862C20.2464 75.6293 19.3232 76.6231 19.1703 77.853Z",
    fill: "#494C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0312 100.016V94.4608C15.0312 91.3783 17.4731 88.8498 20.5537 88.7423L22.0691 88.6895H26.3634L27.7545 88.7388C30.8751 88.8496 33.3858 91.3412 33.5205 94.4608V100.016L24.1743 101.828L15.0312 100.016Z",
    fill: "#BBC3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1098 88.3273V86.435C22.1098 86.171 22.3238 85.957 22.5878 85.957H25.6944C25.9584 85.957 26.1724 86.171 26.1724 86.435V88.3273C26.1724 88.4183 26.1984 88.5074 26.2472 88.5842L26.85 89.5315C26.9537 89.6946 27.0088 89.8839 27.0088 90.0771C27.0088 90.3563 26.894 90.6232 26.6913 90.8151L26.1161 91.3599C25.0689 92.3516 23.4405 92.3884 22.3495 91.445L21.6123 90.8075C21.3971 90.6214 21.2734 90.3509 21.2734 90.0664C21.2734 89.8801 21.3266 89.6977 21.4266 89.5405L22.035 88.5842C22.0839 88.5074 22.1098 88.4183 22.1098 88.3273Z",
    fill: "#A2ABB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3372 82.295L28.9941 83.0385C28.8736 83.2995 28.6506 83.4991 28.3779 83.59C28.1929 83.6517 28.0409 83.7859 27.9567 83.9619L27.3232 85.2866C26.9713 86.0225 26.3436 86.5901 25.5762 86.8665L25.3719 86.94C24.3474 87.3089 23.2263 87.3089 22.2018 86.94C21.3272 86.6251 20.6712 85.8893 20.4584 84.9845L20.0987 83.4558C19.9304 82.7402 19.9035 81.9985 20.0196 81.2726L20.0939 80.8086C20.2445 79.8667 20.562 78.9591 21.0313 78.1287L21.6875 76.9675C21.7841 76.7966 22.0136 76.758 22.1608 76.8879L23.8299 78.3609C23.8803 78.4053 23.9395 78.4387 24.0036 78.4587L25.8181 79.0258L26.4981 79.3122C27.4723 79.7224 28.1301 80.6491 28.196 81.7041C28.1995 81.7596 28.2732 81.7763 28.3002 81.7277L28.5358 81.3035C28.6588 81.0821 28.9726 81.0694 29.1131 81.2802L29.2773 81.5265C29.4295 81.7548 29.4522 82.0458 29.3372 82.295Z",
    fill: "url(#paint2_linear_3752_129141)"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.10156,
    y1: 63.7666,
    x2: 112.555,
    y2: 63.7666,
    stroke: "black",
    strokeWidth: 0.533263
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97266 109.895H13.3721V110.962H5.90625V103.496H6.97266V109.895ZM117.358 110.962H109.893V109.895H116.292V103.496H117.358V110.962ZM13.3721 14.4404H6.97266V20.8398H5.90625V13.374H13.3721V14.4404ZM117.358 20.8398H116.292V14.4404H109.893V13.374H117.358V20.8398Z",
    fill: "#1FACB1"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 70.8601,
    y: 88.5711,
    width: 35.4282,
    height: 35.4282
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.48px)",
      clipPath: "url(#bgblur_0_3752_129141_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 2.95238,
    x: 73.8125,
    y: 91.5234,
    width: 29.5238,
    height: 29.5238,
    rx: 14.7619,
    fill: "#9AE5E7",
    fillOpacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.5751,
    cy: 106.285,
    r: 11.8095,
    fill: "#04BEC4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4541 103.113C94.6944 103.88 93.9375 104.629 93.1779 105.376C91.4546 107.07 89.731 108.764 88.0043 110.455C87.8063 110.649 87.5846 110.796 87.2929 110.86C86.8539 110.956 86.4838 110.835 86.1881 110.55C84.8611 109.266 83.548 107.969 82.234 106.672C81.933 106.376 81.8375 105.794 82.0282 105.402C82.2359 104.976 82.5688 104.732 83.0742 104.707C83.5115 104.686 83.8426 104.866 84.1324 105.149C85.105 106.098 86.0727 107.053 87.0457 108.009C89.2507 105.843 91.4519 103.677 93.6567 101.515C94.1691 101.013 94.8832 100.977 95.4189 101.472C95.8606 101.879 95.9138 102.655 95.4541 103.113Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_3752_129141_clip_path",
    transform: "translate(-70.8601 -88.5711)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.8125,
    y: 91.5234,
    width: 29.5238,
    height: 29.5238,
    rx: 14.7619
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3752_129141",
    x1: 53.2334,
    y1: 19.5818,
    x2: 53.7944,
    y2: 65.2074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392372,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D1DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3752_129141",
    x1: 62.8615,
    y1: 105.802,
    x2: 61.4488,
    y2: 64.6849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392372,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D1DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3752_129141",
    x1: 21.8863,
    y1: 78.3192,
    x2: 26.526,
    y2: 85.9603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABB4BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassportOk);
export default __webpack_public_path__ + "static/media/PassportOk.8a4016834f365546ba72fa3266a233f7.svg";
export { ForwardRef as ReactComponent };